var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/camera"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.17654 15.1673H12.1632C14.0032 15.1673 14.7365 14.0407 14.8232 12.6673L15.1699 7.16065C15.2632 5.72065 14.1165 4.50065 12.6699 4.50065C12.2632 4.50065 11.8899 4.26732 11.7032 3.90732L11.2232 2.94065C10.9165 2.33398 10.1165 1.83398 9.43654 1.83398H7.90987C7.2232 1.83398 6.4232 2.33398 6.11654 2.94065L5.63654 3.90732C5.44987 4.26732 5.07654 4.50065 4.66987 4.50065C3.2232 4.50065 2.07654 5.72065 2.16987 7.16065L2.51654 12.6673C2.59654 14.0407 3.33654 15.1673 5.17654 15.1673Z",
    stroke: "#9094A2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.67008 12.4993C9.86342 12.4993 10.8368 11.526 10.8368 10.3327C10.8368 9.13935 9.86342 8.16602 8.67008 8.16602C7.47675 8.16602 6.50342 9.13935 6.50342 10.3327C6.50342 11.526 7.47675 12.4993 8.67008 12.4993Z",
    stroke: "#9094A2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.695d7a469cca24740f4fd72a8ca89d7e.svg";
export { ForwardRef as ReactComponent };